export default "__VITE_ASSET__Cqse9Ol7__"